import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTickets, raiseTicket, patchTicket } from '../../services/api/ticketService';

export const loadTickets = createAsyncThunk('tickets/load', async () => fetchTickets());

export const createNewTicket = createAsyncThunk('tickets/create', async (payload, { rejectWithValue }) => {
  try { return await raiseTicket(payload); }
  catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Ticket could not be created.'); }
});

export const updateTicketRecord = createAsyncThunk(
  'tickets/update',
  async ({ id, changes }, { rejectWithValue }) => {
    try { return await patchTicket(id, changes); }
    catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Ticket could not be updated.'); }
  }
);

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState: { status: 'idle', mutationStatus: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadTickets.pending, (state) => { state.status = 'loading'; })
      .addCase(loadTickets.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadTickets.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createNewTicket.pending, (state) => { state.mutationStatus = 'loading'; state.error = null; })
      .addCase(updateTicketRecord.pending, (state) => { state.mutationStatus = 'loading'; state.error = null; })
      .addCase(createNewTicket.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        state.items.unshift(action.payload);
      })
      .addCase(updateTicketRecord.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        const item = state.items.find((t) => t.id === action.payload.id);
        if (item) Object.assign(item, action.payload);
      })
      .addCase(createNewTicket.rejected, (state, action) => { state.mutationStatus = 'failed'; state.error = action.payload || action.error.message || 'Ticket could not be created.'; })
      .addCase(updateTicketRecord.rejected, (state, action) => { state.mutationStatus = 'failed'; state.error = action.payload || action.error.message || 'Ticket could not be updated.'; });
  }
});

export default ticketsSlice.reducer;
